<form *ngIf="searchForm && (isLoading == false)" [formGroup]="searchForm" autocomplete="off" name="dummy"
  [class.SmallArabicFont]="globalService.isRTL == true">
<div class="row">
    <div class="form-group col-6" [class.text-right]="globalService.isRTL == true">
      <label for="firstName">{{ globalService.Get("FIRSTNAME") }}</label>
      <input type="text" id="firstName" class="form-control" formControlName="firstName" />
    </div>
    <div class="form-group col-6" [class.text-right]="globalService.isRTL == true">
      <label for="lastName">{{ globalService.Get("LASTNAME") }}</label>
      <input type="text" id="lastName" class="form-control" formControlName="lastName" />
    </div>

  </div>



  <div class="row filter-actions" [class.group-filter-actions]="DefaultGroup != null">
    <div class="form-group col-12" *ngIf="errorMessage">
      <app-prompt-message [showForm]="errorMessage !=''" color="danger"
        (onClose)="errorMessage = ''" [message]="globalService.Get(errorMessage)">
      </app-prompt-message>
    </div>
    <div class="form-group" [class.col-6]="ShowAdvancedSearch == 'true'" [class.col-12]="ShowAdvancedSearch != 'true'"
      *ngIf="DefaultGroup == null">
      <button class="btn btn-primary btn-block" [class.pt-2]="globalService.isRTL == true" type="button" [disabled]="memberSearching || groupSearching" [attr.aria-busy]="memberSearching" [class.search-pending]="memberSearching" (click)="onSubmit()">
        <div *ngIf="!memberSearching" [class.SmallArabicFont]="globalService.isRTL == true">
          <span>
            <i class="fas fa-search"></i>
            {{ globalService.Get("SEARCH") }}
          </span>
        </div>
        <div *ngIf="memberSearching" [class.SmallArabicFont]="globalService.isRTL == true">
          <span>
            <i class="fas fa-spinner fa-spin"></i>
            {{ globalService.Get("SEARCH") }}
          </span>
        </div>
      </button>
    </div>
    <div class="form-group col-12" [class.text-right]="globalService.isRTL == true"
      [class.col-md-6]="ShowAdvancedSearch == 'false'" [class.col-md-3]="ShowAdvancedSearch == 'true'"
      *ngIf="DefaultGroup != null">
      <button class="btn btn-primary btn-block" [class.pt-2]="globalService.isRTL == true" type="button" [disabled]="memberSearching || groupSearching" [attr.aria-busy]="memberSearching" [class.search-pending]="memberSearching" (click)="onSubmit()">
        <div *ngIf="!memberSearching">
          <span>
            <i class="fas fa-search"></i>
            {{ globalService.isRTL ? globalService.Get('SEARCH') : ('FIND_MATCHES' | translate) }}
          </span>
        </div>
        <div *ngIf="memberSearching">
          <span>
            <i class="fas fa-spinner fa-spin"></i>
            {{ globalService.isRTL ? globalService.Get('SEARCH') : ('FIND_MATCHES' | translate) }}
          </span>
        </div>
      </button>
    </div>
    <div class="form-group col-12" [class.text-right]="globalService.isRTL == true"
      [class.col-md-6]="ShowAdvancedSearch == 'false'" [class.col-md-3]="ShowAdvancedSearch == 'true'"
      *ngIf="DefaultGroup != null">
      <button class="btn btn-primary btn-block" type="button" [disabled]="memberSearching || groupSearching" [attr.aria-busy]="groupSearching" [class.search-pending]="groupSearching" (click)="ShowGroup()">
        <div *ngIf="!groupSearching">
          <span>
            <i class="fas fa-users"></i>
            {{ globalService.isRTL ? globalService.Get(GroupName()) : ('CURRENT_MEMBERS' | translate) }}
          </span>
        </div>
        <div *ngIf="groupSearching">
          <span>
            <i class="fas fa-spinner fa-spin"></i>
            {{ globalService.isRTL ? globalService.Get(GroupName()) : ('CURRENT_MEMBERS' | translate) }}
          </span>
        </div>
      </button>
    </div>
    <div *ngIf="ShowAdvancedSearch == 'true' && isLoading == false"
      class="form-group col-3 col-md-2" [class.text-right]="globalService.isRTL == true">
      <button class="btn btn btn-primary btn-block" [class.pt-2]="globalService.isRTL == true" type="button"
        [disabled]="searchForm.pristine" (click)="ClearFilter()">
        <span> {{ globalService.Get("CLEAR") }} </span>
      </button>
    </div>
    <div class="form-group col-3 col-md-4" *ngIf="ShowAdvancedSearch == 'true'">
      <button class="btn btn btn-danger btn-block" [class.pt-2]="globalService.isRTL == true"
        type="button" [attr.aria-expanded]="advancedSearch" (click)="advancedSearch = !advancedSearch">
        <span>
          <i class="fas" [class.fa-chevron-circle-down]="!advancedSearch" [class.fa-chevron-circle-up]="advancedSearch"></i>
          {{ globalService.Get(advancedSearch ? "LESS" : "MORE") }}
        </span>
      </button>
    </div>
  </div>
  <div class="row" *ngIf="advancedSearch || ShowAdvancedSearch == 'false'" autocomplete="off">
    <details class="filter-section col-12" *ngIf="NotesFilter == 'true'">
      <summary>{{ globalService.Get("NOTES") }} <span class="filter-count" *ngIf="activeFilterCount('notes')">{{ 'VALUE0_ACTIVE' | translate:{value0:(activeFilterCount('notes'))} }}</span></summary>
      <div class="row pt-3">    <div class="form-group col-12" [class.text-right]="globalService.isRTL == true" *ngIf="NotesFilter == 'true'">
      <label for="note_selection">{{ globalService.Get("NOTES") }}</label>
      <div>
        <select class="form-control classic" formControlName="note_selection" style="min-width: 120px"
          [class.classicRTL]="globalService.isRTL == true" [class.classic]="globalService.isRTL == false">
          <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
          <option [ngValue]="0" selected>
            {{ globalService.Get("SHOW_ALL") }}
          </option>
          <option [ngValue]="1">{{ globalService.Get("WITH_NOTES") }}</option>
          <option [ngValue]="2">
            {{ globalService.Get("WITHOUT_NOTES") }}
          </option>
        </select>
      </div>
    </div></div>
    </details>
    <details class="filter-section col-12" *ngIf="FollowupFilter == 'true'" [open]="!collapseTask" (toggle)="collapseTask = !$any($event.target).open">
      <summary>{{ globalService.Get("TASKS") }} <span class="filter-count" *ngIf="activeFilterCount('tasks')">{{ 'VALUE0_ACTIVE' | translate:{value0:(activeFilterCount('tasks'))} }}</span></summary>
  <div class="row pt-3">
    <div class="form-group col-6" [class.text-right]="globalService.isRTL == true" *ngIf="FollowupFilter == 'true'">
      <label for="status" class="text-secondary" [class.SmallArabicFont]="globalService.isRTL == true">{{
        globalService.Get("STATUS") }}</label>
      <select id="status" class="form-control" [class.classicRTL]="globalService.isRTL == true"
        (change)="statusChanged()" [class.classic]="globalService.isRTL == false" formControlName="outReachStatus">
        <option [ngValue]="null" selected>
          {{ globalService.Get("SELECT") }}
        </option>
        <option [ngValue]="0">
          {{ globalService.Get("PLANNED") }}
        </option>
        <option [ngValue]="1">
          {{ globalService.Get("COMPLETE") }}
        </option>
        <option [ngValue]="3">
          {{ globalService.Get("NOT_PLANNED") }}
        </option>
        <option [ngValue]="4">
          {{ globalService.Get("NOT_COMPLETED") }}
        </option>
      </select>
    </div>
    <div class="form-group col-6" [class.text-right]="globalService.isRTL == true" *ngIf="FollowupFilter == 'true'">
      <label for="task" class="text-secondary" [class.SmallArabicFont]="globalService.isRTL == true">{{
        globalService.Get("TASK") }}</label>
      <select class="form-control" [class.classicRTL]="globalService.isRTL == true"
        [class.classic]="globalService.isRTL == false" formControlName="outReachTask">
        <option [ngValue]="null" selected>
          {{ globalService.Get("SELECT") }}
        </option>
        <option [ngValue]="0">
          {{ globalService.Get("VISIT") }}
        </option>
        <option [ngValue]="1">
          {{ globalService.Get("CALL") }}
        </option>
        <option [ngValue]="2">
          {{ globalService.Get("TEXT") }}
        </option>
        <option [ngValue]="3">
          {{ globalService.Get("EMAIL") }}
        </option>
        <option [ngValue]="4">
          {{ globalService.Get("ANY_OF_ABOVE") }}
        </option>
      </select>
    </div>
    <div class="form-group col-12" [class.text-right]="globalService.isRTL == true"
      *ngIf="FollowupFilter == 'true' && AttendanceFilter == 'true'">
      <label for="followupDateRange">{{ globalService.Get("DATE_RANGE") }}</label>
      <div>
        <select class="form-control" formControlName="followupDateRange" (change)="followup_date_range_changed()"
          [class.classicRTL]="globalService.isRTL == true" [class.classic]="globalService.isRTL == false">
          <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
          <option [ngValue]='1'> {{ 'LAST_WEEK' | translate }}</option>
          <option [ngValue]='2'> {{ 'LAST_2_WEEKS' | translate }}</option>
          <option [ngValue]='3'> {{ 'LAST_3_WEEKS' | translate }}</option>
          <option [ngValue]='4'> {{ 'LAST_MONTH' | translate }}</option>
          <option [ngValue]='5'> {{ 'LAST_3_MONTHS' | translate }}</option>
          <option [ngValue]='6'> {{ 'LAST_6_MONTHS' | translate }}</option>
          <option [ngValue]='7'> {{ 'LAST_YEAR' | translate }}</option>
          <option [ngValue]='8'> {{ 'LAST_5_YEARS' | translate }}</option>
          <option [ngValue]='9'> {{ 'CUSTOM' | translate }}</option>
        </select>
      </div>
    </div>
    <div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
      *ngIf="FollowupFilter == 'true' && AttendanceFilter == 'true'">
      <label for="ostartDate">{{
        globalService.Get("STARTDATE")
        }}</label>
      <div>
        <div class="input-group">
          <input id="ostartDate" formControlName="outReachStartDate" class="form-control" matInput
            [matDatepicker]="ostartDate" [placeholder]="'MM_DD_YYYY' | translate" required
            [disabled]="searchForm.get('followupDateRange').value != 9"
            (click)="globalService.OpenCalendar(ostartDate)" />
          <mat-datepicker [touchUi]="
              (globalService.isHandset$ | async) ? 'true' : 'false'
            " #ostartDate></mat-datepicker>
          <div class="input-group-append">
            <button type="button" class="btn btn-secondary btn-small input-group-text"
              (click)="globalService.OpenCalendar(ostartDate)">
              <span>
                <i class="fas fa-calendar-alt"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
      *ngIf="FollowupFilter == 'true' && AttendanceFilter == 'true'">
      <label for="oendDate">{{
        globalService.Get("ENDDATE")
        }}</label>
      <div>
        <div class="input-group">
          <input id="oendDate" formControlName="outReachEndDate" class="form-control" matInput
            [matDatepicker]="oendDate" [placeholder]="'MM_DD_YYYY' | translate" required
            [disabled]="searchForm.get('followupDateRange').value != 9"
            (click)="globalService.OpenCalendar(oendDate)" />
          <mat-datepicker [touchUi]="
              (globalService.isHandset$ | async) ? 'true' : 'false'
            " #oendDate></mat-datepicker>
          <div class="input-group-append">
            <button type="button" class="btn btn-secondary btn-small input-group-text"
              (click)="globalService.OpenCalendar(oendDate)">
              <span>
                <i class="fas fa-calendar-alt"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group col-12" *ngIf="FollowupFilter == 'true'">
      <div class="btn-group col-12 mt-4">
        <label [class.SmallArabicFont]="globalService.isRTL == true">
          <input type="checkbox" [(ngModel)]="showMassText" [ngModelOptions]="{standalone: true}" (change)="toggleMassText()" />
          {{ globalService.Get("INCLUDE_MASS_TEXT") }}
        </label>
      </div>
    </div>
    <div class="form-group col-12" [class.text-right]="globalService.isRTL == true" *ngIf="FollowupFilter == 'true'">
      <label for="task" class="text-secondary" [class.SmallArabicFont]="globalService.isRTL == true">{{
        globalService.Get("ASSIGNEE") }}</label>
      <select class="form-control" [class.classicRTL]="globalService.isRTL == true" (change)="assigneeChanged($event)"
        [class.classic]="globalService.isRTL == false" formControlName="outReachAssignee">
        <option [ngValue]="null" selected>
          {{ globalService.Get("SELECT") }}
        </option>
        <option *ngFor="let assignee of assignees" [ngValue]="assignee.id">
          {{ assignee.name }}
        </option>
      </select>
    </div>
  </div>
    </details>

    <details class="filter-section col-12" *ngIf="AttendanceFilter == 'true'" [open]="!collapseAttendance" (toggle)="collapseAttendance = !$any($event.target).open">
      <summary>{{ globalService.Get("ATTENDANCE") }}</summary>
  <div class="row pt-3">
    <div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
      *ngIf="AttendanceFilter == 'true'">
      <label for="status" class="text-secondary" [class.SmallArabicFont]="globalService.isRTL == true">{{
        globalService.Get("STATUS") }}</label>
      <select id="status" class="form-control" [class.classicRTL]="globalService.isRTL == true"
        (change)="statusChanged()" [class.classic]="globalService.isRTL == false" formControlName="attendanceStatus">
        <option [ngValue]="2" selected>
          {{ globalService.Get("SHOW_ALL") }}
        </option>
        <option [ngValue]="0">
          {{ globalService.Get("ATTENDED") }}
        </option>
        <option [ngValue]="1">
          {{ globalService.Get("NOT_ATTENDED") }}
        </option>
      </select>
    </div>
    <div class="form-group col-md-6 d-none d-md-block"
      *ngIf="(AttendanceFilter == 'true') && (searchForm.get('attendanceStatus').value != 0)"></div>
    <div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
      *ngIf="AttendanceFilter == 'true' && searchForm.get('attendanceStatus').value == 0">
      <label for="duration">{{ globalService.Get("ATTENDANCE_FREQUENCY") }}</label>
      <div class="input-group">
        <div class="input-group-append">
          <select class="form-control classic" formControlName="frequencyType" style="min-width: 120px"
            (change)="FrequencyTypeChanged()" [class.classicRTL]="globalService.isRTL == true"
            [class.classic]="globalService.isRTL == false">
            <option [ngValue]="null" disabled>{{ globalService.Get("SELECT") }}</option>
            <option [ngValue]="1">
              {{ globalService.Get("MORE_THAN") }}
            </option>
            <option [ngValue]="2">{{ globalService.Get("LESS_THAN") }}</option>
          </select>
        </div>
        <div class="input-group-append" style="width: 60px">
          <input type="text" class="form-control" [readonly]="
              searchForm.get('frequencyType').value == null" formControlName="frequency" />
        </div>
        <div class="input-group-append">
          <label class="form-label m-2">{{ 'TIMES' | translate }}</label>
        </div>
      </div>
    </div>
    <div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
      *ngIf="AttendanceFilter == 'true'">
      <label for="category">{{ globalService.Get("CATEGORY") }}</label>
      <div>
        <select class="form-control" (change)="clearService()" formControlName="category" (change)="onCategoryChange()"
          [class.classicRTL]="globalService.isRTL == true" [class.classic]="globalService.isRTL == false">
          <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
          <option *ngFor="let group of groupArr" [ngValue]="group.id">
            {{ group.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
      *ngIf="AttendanceFilter == 'true'">
      <label for="service">{{ globalService.Get("SERVICE") }}</label>
      <div>
        <select class="form-control" formControlName="service" (change)="clearCategory()"
          [class.classicRTL]="globalService.isRTL == true" [class.classic]="globalService.isRTL == false">
          <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
          <option *ngFor="let service of serviceArr" [ngValue]="service.id">
            {{ service.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group col-12" [class.text-right]="globalService.isRTL == true" *ngIf="AttendanceFilter == 'true'">
      <label for="attendanceDateRange">{{ globalService.Get("DATE_RANGE") }}</label>
      <div>
        <select class="form-control" formControlName="attendanceDateRange" (change)="date_range_changed()"
          [class.classicRTL]="globalService.isRTL == true" [class.classic]="globalService.isRTL == false">
          <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
          <option [ngValue]='1'> {{ 'LAST_WEEK' | translate }}</option>
          <option [ngValue]='2'> {{ 'LAST_2_WEEKS' | translate }}</option>
          <option [ngValue]='3'> {{ 'LAST_3_WEEKS' | translate }}</option>
          <option [ngValue]='4'> {{ 'LAST_MONTH' | translate }}</option>
          <option [ngValue]='5'> {{ 'LAST_3_MONTHS' | translate }}</option>
          <option [ngValue]='6'> {{ 'LAST_6_MONTHS' | translate }}</option>
          <option [ngValue]='7'> {{ 'LAST_YEAR' | translate }}</option>
          <option [ngValue]='8'> {{ 'LAST_5_YEARS' | translate }}</option>
          <option [ngValue]='9'> {{ 'CUSTOM' | translate }}</option>
        </select>
      </div>
    </div>
    <div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
      *ngIf="AttendanceFilter == 'true'">
      <label for="astartDate">{{
        globalService.Get("STARTDATE")
        }}</label>
      <div class="input-group">
        <input id="astartDate" formControlName="attendanceStartDate" class="form-control" matInput
          [matDatepicker]="astartDate" [placeholder]="'MM_DD_YYYY' | translate" required
          [disabled]="searchForm.get('attendanceDateRange').value != 9"
          (click)="globalService.OpenCalendar(astartDate)" />
        <mat-datepicker [touchUi]="
              (globalService.isHandset$ | async) ? 'true' : 'false'
            " #astartDate></mat-datepicker>
        <div class="input-group-append">
          <button type="button" class="btn btn-secondary btn-small input-group-text"
            (click)="globalService.OpenCalendar(astartDate)">
            <span>
              <i class="fas fa-calendar-alt"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
      *ngIf="AttendanceFilter == 'true'">
      <label for="aendDate">{{
        globalService.Get("ENDDATE")
        }}</label>
      <div class="input-group">
        <input id="aendDate" formControlName="attendanceEndDate" class="form-control" matInput
          [matDatepicker]="aendDate" [placeholder]="'MM_DD_YYYY' | translate" required
          [disabled]="searchForm.get('attendanceDateRange').value != 9"
          (click)="globalService.OpenCalendar(aendDate)" />
        <mat-datepicker [touchUi]="
              (globalService.isHandset$ | async) ? 'true' : 'false'
            " #aendDate></mat-datepicker>
        <div class="input-group-append">
          <button type="button" class="btn btn-secondary btn-small input-group-text"
            (click)="globalService.OpenCalendar(aendDate)">
            <span>
              <i class="fas fa-calendar-alt"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
    </details>
    <details class="filter-section col-12" *ngIf="DonationFilter == 'true'" [open]="!collapseGiving" (toggle)="collapseGiving = !$any($event.target).open">
      <summary>{{ globalService.Get("GIVING") }}</summary>
  <div class="row pt-3">
    <div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
      *ngIf="DonationFilter == 'true'">
      <label for="singleDonationMode" class="text-secondary" [class.SmallArabicFont]="globalService.isRTL == true">{{
        globalService.Get("DONATION_LEVEL") }}</label>
      <select id="singleDonationMode" class="form-control" [class.classicRTL]="globalService.isRTL == true"
        (change)="donationModeChanged()" [class.classic]="globalService.isRTL == false"
        formControlName="singleDonationMode">
        <option [ngValue]="false" selected>
          {{ globalService.Get("TOTAL_DONATION") }}
        </option>
        <option [ngValue]="true">
          {{ globalService.Get("SINGLE_DONATION") }}
        </option>
      </select>
    </div>
    <div class="form-group col-6 col-md-3" [class.text-right]="globalService.isRTL == true"
      *ngIf="DonationFilter == 'true'">
      <label for="donationStartRange" class="text-secondary" [class.SmallArabicFont]="globalService.isRTL == true">{{
        globalService.Get("DONATION_START_RANGE") }}</label>
      <input type="number" id="donationStartRange" class="form-control" formControlName="donationStartRange" />
    </div>
    <div class="form-group col-6 col-md-3" [class.text-right]="globalService.isRTL == true"
      *ngIf="DonationFilter == 'true'">
      <label for="donationEndRange" class="text-secondary" [class.SmallArabicFont]="globalService.isRTL == true">{{
        globalService.Get("DONATION_END_RANGE") }}</label>
      <input type="number" id="donationEndRange" class="form-control" formControlName="donationEndRange" />
    </div>
    <div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
      *ngIf="DonationFilter == 'true'">
      <label for="donationDateRange">{{ globalService.Get("DATE_RANGE") }}</label>
      <div>
        <select class="form-control" formControlName="donationDateRange" (change)="donation_date_range_changed()"
          [class.classicRTL]="globalService.isRTL == true" [class.classic]="globalService.isRTL == false">
          <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
          <option [ngValue]='1'> {{ 'LAST_WEEK' | translate }}</option>
          <option [ngValue]='2'> {{ 'LAST_2_WEEKS' | translate }}</option>
          <option [ngValue]='3'> {{ 'LAST_3_WEEKS' | translate }}</option>
          <option [ngValue]='4'> {{ 'LAST_MONTH' | translate }}</option>
          <option [ngValue]='5'> {{ 'LAST_3_MONTHS' | translate }}</option>
          <option [ngValue]='6'> {{ 'LAST_6_MONTHS' | translate }}</option>
          <option [ngValue]='7'> {{ 'LAST_YEAR' | translate }}</option>
          <option [ngValue]='8'> {{ 'LAST_5_YEARS' | translate }}</option>
          <option [ngValue]='9'> {{ 'CUSTOM' | translate }}</option>
        </select>
      </div>
    </div>
    <div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
      *ngIf="AllDonationAccounts == 'true'">
      <label for="includeAccounts" class="text-secondary" [class.SmallArabicFont]="globalService.isRTL == true">{{
        globalService.Get("ACCOUNTS") }}</label>
      <select id="includeAccounts" class="form-control" [class.classicRTL]="globalService.isRTL == true"
        (change)="includeAccountsChanged()" [class.classic]="globalService.isRTL == false"
        formControlName="includeAccounts">
        <option [ngValue]="0" selected>
          {{ globalService.Get("ALL") }}
        </option>
        <option [ngValue]="1">
          {{ globalService.Get("INTERNAL") }}
        </option>
        <option [ngValue]="2">
          {{ globalService.Get("EXTERNAL") }}
        </option>
      </select>
    </div>
    <div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
      *ngIf="DonationFilter == 'true'">
      <label for="dstartDate">{{
        globalService.Get("STARTDATE")
        }}</label>
      <div class="input-group">
        <input id="dstartDate" formControlName="donationStartDate" class="form-control" matInput
          [matDatepicker]="dstartDate" [placeholder]="'MM_DD_YYYY' | translate" required
          [disabled]="searchForm.get('donationDateRange').value != 9"
          (click)="globalService.OpenCalendar(dstartDate)" />
        <mat-datepicker [touchUi]="
            (globalService.isHandset$ | async) ? 'true' : 'false'
          " #dstartDate></mat-datepicker>
        <div class="input-group-append">
          <button type="button" class="btn btn-secondary btn-small input-group-text"
            (click)="globalService.OpenCalendar(dstartDate)">
            <span>
              <i class="fas fa-calendar-alt"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
      *ngIf="DonationFilter == 'true'">
      <label for="dendDate">{{
        globalService.Get("ENDDATE")
        }}</label>
      <div class="input-group">
        <input id="dendDate" formControlName="donationEndDate" class="form-control" matInput [matDatepicker]="dendDate"
          [placeholder]="'MM_DD_YYYY' | translate" required [disabled]="searchForm.get('donationDateRange').value != 9"
          (click)="globalService.OpenCalendar(dendDate)" />
        <mat-datepicker [touchUi]="
            (globalService.isHandset$ | async) ? 'true' : 'false'
          " #dendDate></mat-datepicker>
        <div class="input-group-append">
          <button type="button" class="btn btn-secondary btn-small input-group-text"
            (click)="globalService.OpenCalendar(dendDate)">
            <span>
              <i class="fas fa-calendar-alt"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
    </details>

  </div>
  <div class="row" *ngIf="advancedSearch == true" autocomplete="off">
    <details class="filter-section col-12">
      <summary>{{ 'CONTACT' | translate }}<span class="filter-count" *ngIf="activeFilterCount('contact')">{{ 'VALUE0_ACTIVE' | translate:{value0:(activeFilterCount('contact'))} }}</span></summary>
      <div class="row pt-3">
<div class="form-group col-12" [class.text-right]="globalService.isRTL == true">
      <label for="account">{{ globalService.Get("ACCOUNT_TYPE") }}</label>
      <select id="account" class="form-control classic" formControlName="account"
        [class.classicRTL]="globalService.isRTL == true" [class.classic]="globalService.isRTL == false">
        <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
        <option [ngValue]="0">
          {{ globalService.Get("PRIMARY_ACCOUNT") }}
        </option>
        <option [ngValue]="1">
          {{ globalService.Get("HOUSEHOLD_MEMBER") }}
        </option>
        <option [ngValue]="2">
          {{ globalService.Get("HOUSEHOLD") }}
        </option>
        <option [ngValue]="3">
          {{ globalService.Get("HOUSEHOLD_SINGLE") }}
        </option>
        <option [ngValue]="4">
          {{ globalService.Get("ACCOUNT_INACTIVE_TYPE") }}
        </option>
        <option [ngValue]="5">
          {{ globalService.Get("INVALID_ADDRESS") }}
        </option>
      </select>
    </div>
<div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true">
      <label for="email">{{ globalService.Get("EMAIL") }}</label>
      <input type="text" id="email" class="form-control" formControlName="email" autocomplete="new-email" />
    </div>
<div class="form-group col-6" [class.text-right]="globalService.isRTL == true">
      <label for="firstName">{{ globalService.Get("CELLPHONE") }}</label>
      <input type="text" id="phone" class="form-control" formControlName="phone" autocomplete="new-phone" />
    </div>
      </div>
    </details>
    <details class="filter-section col-12">
      <summary>{{ 'PERSONAL' | translate }}<span class="filter-count" *ngIf="activeFilterCount('personal')">{{ 'VALUE0_ACTIVE' | translate:{value0:(activeFilterCount('personal'))} }}</span></summary>
      <div class="row pt-3">
<div class="form-group col-6" [class.text-right]="globalService.isRTL == true">
      <label for="gender">{{ globalService.Get("GENDER") }}</label>
      <select id="gender" class="form-control classic" formControlName="gender"
        [class.classicRTL]="globalService.isRTL == true" [class.classic]="globalService.isRTL == false">
        <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
        <option [ngValue]="false">{{ globalService.Get("MALE") }}</option>
        <option [ngValue]="true">{{ globalService.Get("FEMALE") }}</option>
      </select>
    </div>
<div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true">
      <label for="maritalStatus">{{
        globalService.Get("MARITAL_STATUS")
        }}</label>
      <select id="maritalStatus" class="form-control classic" formControlName="maritalStatus"
        [class.classicRTL]="globalService.isRTL == true" [class.classic]="globalService.isRTL == false">
        <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
        <option [ngValue]="0">{{ globalService.Get("SINGLE") }}</option>
        <option [ngValue]="1">{{ globalService.Get("ENGAGED") }}</option>
        <option [ngValue]="2">{{ globalService.Get("MARRIED") }}</option>
        <option [ngValue]="3">{{ globalService.Get("WIDOWED") }}</option>
        <option [ngValue]="4">{{ globalService.Get("DIVORCED") }}</option>
        <option [ngValue]="5">{{ globalService.Get("DEPARTED") }}</option>
      </select>
    </div>
<div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true">
      <label for="age">{{ globalService.Get("AGE_RANGES") }}</label>
      <input type="text" id="age" dir="ltr" class="form-control" formControlName="age"
        [placeholder]="'AGE_PLACEHOLDER' | translate" autocomplete="new-age" />
    </div>
<div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true">
      <label for="grade">{{ globalService.Get("SCHOOL_GRADES") }}</label>
      <input type="text" id="grade" dir="ltr" class="form-control" [placeholder]="'GRADE_PLACEHOLDER' | translate"
        formControlName="grade" autocomplete="new-grade" />
    </div>
<div class="form-group col-12" [class.text-right]="globalService.isRTL == true">
      <label for="occupation">{{ globalService.Get("OCCUPATION") }}</label>
      <div>
        <select id="occupation" class="form-control" [class.classicRTL]="globalService.isRTL == true"
          [class.classic]="globalService.isRTL == false" formControlName="occupation">
          <option [ngValue]="null">
            {{ globalService.Get("SELECT") }}
          </option>
          <option *ngFor="let occupation of occupations" [ngValue]="occupation.id">
            {{ occupation.name }}
          </option>
        </select>
      </div>
    </div>
      </div>
    </details>
    <details class="filter-section col-12">
      <summary>{{ 'LOCATION' | translate }}<span class="filter-count" *ngIf="activeFilterCount('location')">{{ 'VALUE0_ACTIVE' | translate:{value0:(activeFilterCount('location'))} }}</span></summary>
      <div class="row pt-3">
<div class="form-group col-12" [class.text-right]="globalService.isRTL == true">
      <label for="city">{{ globalService.Get("CITIES") }}</label>
      <input type="text" id="city" class="form-control" [placeholder]="globalService.Get('CITY_PLACEHOLDER')"
        formControlName="city" autocomplete="new-city" />
    </div>
<div class="form-group col-7" [class.text-right]="globalService.isRTL == true">
      <label for="state">{{ globalService.Get("STATES") }}</label>
      <input type="text" id="state" class="form-control" [placeholder]="globalService.Get('STATE_PLACEHOLDER')"
        formControlName="state" autocomplete="new-state" />
    </div>
<div class="form-group col-5" [class.text-right]="globalService.isRTL == true">
      <label for="zip">{{ globalService.Get("ZIPCODES") }}</label>
      <input type="text" id="zip" class="form-control text-left" dir="ltr"
        [placeholder]="globalService.Get('ZIP_PLACEHOLDER')" formControlName="zip" />
    </div>
      </div>
    </details>
    <details class="filter-section col-12">
      <summary>{{ 'CHURCH_GROUPS' | translate }}<span class="filter-count" *ngIf="activeFilterCount('church')">{{ 'VALUE0_ACTIVE' | translate:{value0:(activeFilterCount('church'))} }}</span></summary>
      <div class="row pt-3">
<div class="form-group col-12" [class.text-right]="globalService.isRTL == true" *ngIf="isDiocese == true">
      <label for="diocese">{{ globalService.Get("CHURCH") }}</label>
      <div>
        <select class="form-control classic" formControlName="diocese" [class.classicRTL]="globalService.isRTL == true"
          [class.classic]="globalService.isRTL == false">
          <option [ngValue]="0">{{ globalService.Get("SELECT") }}</option>
          <option *ngFor="let church of tenants" [ngValue]="church.id">
            {{ church.name }}
          </option>
        </select>
      </div>
    </div>
<div class="form-group col-12 col-md-4" [class.text-right]="globalService.isRTL == true">
      <label for="department">{{ globalService.Get("DEPARTMENT") }}</label>
      <div>
        <select class="form-control classic" formControlName="department"
          [class.classicRTL]="globalService.isRTL == true" [class.classic]="globalService.isRTL == false">
          <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
          <option *ngFor="let department of departmentService.departmentArr" [ngValue]="department.id">
            {{ department.name }}
          </option>
        </select>
      </div>
    </div>
<div class="form-group col-12 col-md-4" [class.text-right]="globalService.isRTL == true">
      <label for="superGroup">{{ globalService.Get("SUPERGROUP") }}</label>
      <div>
        <select class="form-control classic" formControlName="superGroup"
          [class.classicRTL]="globalService.isRTL == true" [class.classic]="globalService.isRTL == false">
          <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
          <option *ngFor="let superGroup of superGroupService.superGroupArr" [ngValue]="superGroup.id">
            {{ superGroup.name }}
          </option>
        </select>
      </div>
    </div>
<div class="form-group col-12 col-md-4" [class.text-right]="globalService.isRTL == true">
      <label for="group">{{ globalService.Get("GROUP") }}</label>
      <div>
        <select class="form-control classic" formControlName="group" [class.classicRTL]="globalService.isRTL == true"
          [class.classic]="globalService.isRTL == false">
          <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
          <option *ngFor="let group of groupService.GroupArr" [ngValue]="group.id">
            {{ group.name }}
          </option>
        </select>
      </div>
    </div>
<div class="form-group col-6" [class.text-right]="globalService.isRTL == true">
      <label for="membership">{{ globalService.Get("MEMBERSHIP") }}</label>
      <select id="membership" class="form-control classic" formControlName="membership"
        [class.classicRTL]="globalService.isRTL == true" [class.classic]="globalService.isRTL == false">
        <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
        <option [ngValue]="true">{{ globalService.Get("MEMBER") }}</option>
        <option [ngValue]="false">{{ globalService.Get("GUEST") }}</option>
      </select>
    </div>
<div class="form-group col-7" [class.text-right]="globalService.isRTL == true">
      <label for="tag">{{ globalService.Get("TAGS") }}</label>
      <div>
        <mat-form-field appearance="outline" class="w-100 compact-field">
          <mat-select formControlName="tag">

            <mat-select-trigger>
              <span class="trigger-content">
                <span class="trigger-text">
                  {{ selectedTag?.name || globalService.Get('SELECT') }}
                </span>

                <span class="color-dot" *ngIf="selectedTag" [ngClass]="selectedTag.color">
                </span>
              </span>
            </mat-select-trigger>

            <mat-option [value]="0">
              {{ globalService.Get("SELECT") }}
            </mat-option>

            <mat-option *ngFor="let tag of tags" [value]="tag.id">
              <div class="tag-option">
                <span>{{ tag.name }}</span>
                <span class="color-dot" [ngClass]="tag.color"></span>
              </div>
            </mat-option>

          </mat-select>
        </mat-form-field>
      </div>
    </div>
      </div>
    </details>
    <details class="filter-section col-12">
      <summary>{{ 'OTHER' | translate }}<span class="filter-count" *ngIf="activeFilterCount('other')">{{ 'VALUE0_ACTIVE' | translate:{value0:(activeFilterCount('other'))} }}</span></summary>
      <div class="row pt-3">
<div class="form-group col-5" [class.text-right]="globalService.isRTL == true">
      <label for="notification">{{ globalService.Get("NOTIFICATION") }}</label>
      <div>
        <select id="notification" class="form-control" [class.classicRTL]="globalService.isRTL == true"
          [class.classic]="globalService.isRTL == false" formControlName="notification">
          <option [ngValue]="0">
            {{ globalService.Get("SELECT") }}
          </option>
          <option [ngValue]="1">
            {{ globalService.Get("ENABLED") }}
          </option>
          <!-- <option [ngValue]="2">
            {{ globalService.Get("DISABLED") }}
          </option> -->
        </select>
      </div>
    </div>
<div class="form-group col-6" [class.text-right]="globalService.isRTL == true">
      <label for="picture">{{ globalService.Get("PROFILE_PICTURE") }}</label>
      <select id="picture" class="form-control classic" formControlName="picture"
        [class.classicRTL]="globalService.isRTL == true" [class.classic]="globalService.isRTL == false">
        <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
        <option [ngValue]="true" selected>
          {{ globalService.Get("YES") }}
        </option>
        <option [ngValue]="false">{{ globalService.Get("NO") }}</option>
      </select>
    </div>
<ng-container formArrayName="extensions" class="col"
      *ngIf="extensions!= null && extensions.controls != null && extensions.controls.length > 0">
      <div *ngFor="let extension of extensions.controls; let i = index" class="form-group col-12 col-md-6">
        <div [formGroupName]="i">
          <label> {{ extension.get("label").value }} </label>
          <div *ngIf="extension.get('options').value == null">
            <input type="text" class="form-control" formControlName="value" />
          </div>
          <div *ngIf="extension.get('options').value != null">
            <select class="form-control" [class.classicRTL]="globalService.isRTL == true" formControlName="value"
              [class.classic]="globalService.isRTL == false">
              <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
              <option *ngFor="let option of extension.get('options').value" [ngValue]="option">
                {{ option }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </ng-container>
<div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true">
      <label for="result">{{ globalService.Get("SEARCH_RESULT") }}</label>
      <select id="result" class="form-control" formControlName="result" [class.classicRTL]="globalService.isRTL == true"
        [class.classic]="globalService.isRTL == false">
        <option [ngValue]="1" selected>
          {{ globalService.Get("INCLUSIVE") }}
        </option>
        <option [ngValue]="2">{{ globalService.Get("EXCLUSIVE") }}</option>
        <option [ngValue]="3">{{ globalService.Get("PARENTS") }}</option>
      </select>
    </div>
<div class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true">
      <label for="result">{{ globalService.Get("HAS_ROLE") }}</label>
      <select id="result" class="form-control" formControlName="has_role"
        [class.classicRTL]="globalService.isRTL == true" [class.classic]="globalService.isRTL == false">
        <option [ngValue]="null">{{ globalService.Get("SELECT") }}</option>
        <option ngValue="Admin">{{ 'ADMIN' | translate }}</option>
        <option ngValue="Attendance Viewer">{{ 'ATTENDANCE_VIEWER' | translate }}</option>
        <option ngValue="Birthday">{{ 'BIRTHDAY' | translate }}</option>
        <option ngValue="Check-in">{{ 'CHECK_IN' | translate }}</option>
        <option ngValue="CMS Administrator">{{ 'CMS_ADMINISTRATOR' | translate }}</option>
        <option ngValue="Communication">{{ 'COMMUNICATION' | translate }}</option>
        <option ngValue="Event Organizer">{{ 'EVENT_ORGANIZER' | translate }}</option>
        <option ngValue="CMS Administrator">{{ 'CMS_ADMINISTRATOR' | translate }}</option>
        <option ngValue="Event Viewer">{{ 'EVENT_VIEWER' | translate }}</option>
        <option ngValue="Form Admin">{{ 'FORM_ADMIN' | translate }}</option>
        <option ngValue="Form Editor">{{ 'FORM_EDITOR' | translate }}</option>
        <option ngValue="Form Viewer">{{ 'FORM_VIEWER' | translate }}</option>
        <option ngValue="Full Profile for Leaders">{{ 'FULL_PROFILE_FOR_LEADERS' | translate }}</option>
        <option ngValue="Giving">{{ 'GIVING' | translate }}</option>
        <option ngValue="Group Admin">{{ 'GROUP_ADMIN' | translate }}</option>
        <option ngValue="Leader">{{ 'LEADER' | translate }}</option>
        <option ngValue="Membership Management">{{ 'MEMBERSHIP_MANAGEMENT_7122C4D' | translate }}</option>
        <option ngValue="Membership Requests">{{ 'MEMBERSHIP_REQUESTS' | translate }}</option>
        <option ngValue="Note Privacy">{{ 'NOTE_PRIVACY' | translate }}</option>
        <option ngValue="Notes Full Access">{{ 'NOTES_FULL_ACCESS' | translate }}</option>
        <option ngValue="Notes Limited Access">{{ 'NOTES_LIMITED_ACCESS' | translate }}</option>
        <option ngValue="Outreach Privacy">{{ 'OUTREACH_PRIVACY' | translate }}</option>
        <option ngValue="Profile Editor">{{ 'PROFILE_EDITOR' | translate }}</option>
        <option ngValue="Profile Viewer">{{ 'PROFILE_VIEWER' | translate }}</option>
        <option ngValue="Registration Exempt">{{ 'REGISTRATION_EXEMPT' | translate }}</option>
        <option ngValue="Service Leader">{{ 'SERVICE_LEADER' | translate }}</option>
        <option ngValue="Task Assignment">{{ 'TASK_ASSIGNMENT' | translate }}</option>
        <option ngValue="Volunteer Leader">{{ 'VOLUNTEER_LEADER' | translate }}</option>
        <option ngValue="Volunteering Admin">{{ 'VOLUNTEERING_ADMIN' | translate }}</option>
        <option ngValue="Any">{{ 'ANY_OF_ABOVE' | translate }}</option>
        <option ngValue="AnyButLeader">{{ 'ANY_BUT_LEADER' | translate }}</option>
      </select>
    </div>
      </div>
    </details>
  </div>
</form>
<div id="AnchorId"></div>